module.exports = __webpack_public_path__ + "img/category-popular-hover.84b491fd.png";